<template>

</template>

<script>
  export default {
    name: 'BlankPage',
    data() {
      return {}
    },
    created() {
      this.$router.push({path: '/Login', query: {id: this.$route.params.id}}) // 跳转到B
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/BlankPage.vue